<template>
    <div class="row">
        <div class="card">
            <div class="card-body">
                <h5 class="card-title">User Home</h5>
                <p>
                    <img
                        src="img/contact-us-phone.jpg"
                        width="257"
                        height="354"
                        class="rounded float-end"
                        alt="contact Certass"
                    />
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                </p>
            </div>
        </div>
    </div>

    <div class="row" v-if="isAuthenticated">
        <div class="row row-cols-1 row-cols-md-2 g-4">
            <span v-for="(item, id) in profileRoles" :key="id">
                <account-role-panel :role="item" />
            </span>
        </div>
    </div>

    <div class="row" v-if="isAuthenticated">
        <account-role-add-panel />
    </div>
</template>
<script lang="js">
import { mapGetters } from "vuex";
import store from '@/store'
import AccountRolePanel from '@/components/AccountRolePanel.vue'
import AccountRoleAddPanel from '@/components/AccountRoleAddPanel.vue'

export default {
    name: 'Home',
    components: {
        'account-role-panel': AccountRolePanel,
        'account-role-add-panel': AccountRoleAddPanel
    },
    data: () => {
        return {
        }
    },
    computed: {
        ...mapGetters(['isAuthenticated', 'profileRoles']),
    },
    methods: {

    },
    created() {
        if (this.isAuthenticated) {
            store.dispatch('getRoles')
        }
    }
}
</script>
<style scoped lang="scss"></style>
